// General api to access data
//git testing
import ApiConstants from '../config/ApiConstants';
export default function api(path, params, method, token) {
  let options;
  options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
      //...(token && {token: token}),
    },
    timeout: 0,
    method: method,
    ...(params && { body: JSON.stringify(params) })
  };
  console.log('request url:', ApiConstants.BASE_URL + path);
  console.log('request:', options);
  return fetch(ApiConstants.BASE_URL + path, options)
    .then((resp) => {
      if (!resp.ok) {
        console.log('response:', resp);
        throw new Error(`Network response was not ok. status: ${resp.status}`);
      }
      return resp.json();
    })
    .then((json) => json)
    .catch((error) => new Error(`Service down, try again later(${error}).`));
}
